import { styled } from '@mui/material';

export const StyledHighlightedText = styled('span')(({ theme }) => ({
  color: theme.palette.custom.coralDusk[400]
}));
